import * as yup from "yup";

import { dobValidationSchema } from "@/containers/Dashboard/Providers/schema/newPatientValidation";

export const ACCOUNT_LOOKUP_VALIDATION = yup.object().shape({
  dob: dobValidationSchema.required("Date of birth is required"),
  email: yup.string().email("Enter a valid email address").required("Email is required"),
  email_validation: yup
    .string()
    .email("Enter a valid email address")
    .required("Email is required")
    .test("email-match", "Email address does not match, please check spelling", function (value) {
      if (!value) {
        return false;
      }

      return this.parent.email === value;
    }),
});
